const LOGOS_BASE_URL = 'https://dosya.atmturkiye.com';
const BUCKET_NAME = 'atmpoint';
const FOLDER_PATH = 'logos';

function generateLogoUrl(filename) {
  return `${LOGOS_BASE_URL}/${BUCKET_NAME}/${FOLDER_PATH}%2F${filename}`;
}

const commonBankLogos = [
  'akbank.png', 'albaraka.png', 'deniz.png', 'finans.png', 'garanti.png',
  'halkbank.png', 'hbsc.png', 'ing.png', 'is.png', 'kuveyt.png',
  'odeabank.png', 'ptt.png', 'qnb.png', 'sekerbank.png', 'teb.png',
  'vakif.png', 'yapikredi.png', 'ziraat.png'
];

const fileKeyToUrl = {};
commonBankLogos.forEach((filename) => {
  const base = filename.replace(/\.(png|jpe?g|svg)$/i, '');
  fileKeyToUrl[base.toLowerCase()] = generateLogoUrl(filename);
});

function normalizeName(text) {
  if (!text) return '';
  return text
    .toString()
    .replace(/[ıİ]/g, 'i')
    .replace(/[şŞ]/g, 's')
    .replace(/[çÇ]/g, 'c')
    .replace(/[ğĞ]/g, 'g')
    .replace(/[öÖ]/g, 'o')
    .replace(/[üÜ]/g, 'u')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/&/g, 've')
    .replace(/[^a-z0-9]/g, '');
}

const aliases = {
  akbank: 'akbank',
  albaraka: 'albaraka',
  denizbank: 'deniz',
  finansbank: 'finans',
  garanti: 'garanti',
  halkbank: 'halkbank',
  hsbc: 'hsbc',
  ingbank: 'ing',
  ing: 'ing',
  isbank: 'is',
  isbankasi: 'is',
  kuveyt: 'kuveyt',
  odeabank: 'odeabank',
  ptt: 'ptt',
  qnb: 'qnb',
  qnbfinansbank: 'qnb',
  sekerbank: 'sekerbank',
  tam: 'tam',
  teb: 'teb',
  vakifbank: 'vakif',
  vakif: 'vakif',
  yapikredi: 'yapikredi',
  ziraatbankasi: 'ziraat',
  ziraat: 'ziraat',
};

export function getBankLogo(bankName) {
  if (!bankName) return null;
  const normalized = normalizeName(bankName);
  const aliasKey = aliases[normalized];
  
  if (aliasKey && fileKeyToUrl[aliasKey]) {
    return fileKeyToUrl[aliasKey];
  }
  if (fileKeyToUrl[normalized]) {
    return fileKeyToUrl[normalized];
  }
  
  const stripped = normalized
    .replace(/(bankasi|banka|bank)$/i, '')
    .replace(/(anonimsirketi|as)$/i, '');
  if (stripped && fileKeyToUrl[stripped]) {
    return fileKeyToUrl[stripped];
  }
  if (aliases[stripped] && fileKeyToUrl[aliases[stripped]]) {
    return fileKeyToUrl[aliases[stripped]];
  }
  
  const keys = Object.keys(fileKeyToUrl);
  const containsKey = keys.find((k) => normalized.includes(k));
  if (containsKey) return fileKeyToUrl[containsKey];

  const containedByKey = keys.find((k) => k.includes(normalized));
  if (containedByKey) return fileKeyToUrl[containedByKey];

  if (stripped) {
    const containsStripped = keys.find((k) => stripped.includes(k) || k.includes(stripped));
    if (containsStripped) return fileKeyToUrl[containsStripped];
  }

  const fallbackUrl = generateLogoUrl(`${normalized}.png`);
  
  return fallbackUrl;
}

export const bankLogosMap = { ...fileKeyToUrl };